import { render, staticRenderFns } from "./superuser-anonymous-order-return.vue?vue&type=template&id=5a80a2c7&"
import script from "./superuser-anonymous-order-return.vue?vue&type=script&lang=js&"
export * from "./superuser-anonymous-order-return.vue?vue&type=script&lang=js&"
import style0 from "./superuser-anonymous-order-return.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports